import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import {IAdditionalEmail, IAdditionalEmailAdd, INotifyChannelEdit} from '../model/INotifyChannel';

import {notifyChannelApiOptions, notifyChannelEndpoints} from './notifyChannelEndpoints';

const endpoints = notifyChannelEndpoints<IAdditionalEmail, IAdditionalEmailAdd, INotifyChannelEdit>({
    list: ApiUrls.ADDITIONAL_EMAILS,
    item: ApiUrls.ADDITIONAL_EMAIL,
    testNotify: ApiUrls.ADDITIONAL_EMAIL_SEND_TEST_NOTIFY,
});

export const additionalEmailAPI = createApi({
    reducerPath: 'additionalEmailAPI',
    baseQuery: httpBaseQuery(),
    ...notifyChannelApiOptions,
    endpoints: (build) => ({
        ...endpoints(build),
        addWithConfirmed: build.mutation<{message?: string}, IAdditionalEmailAdd>({
            query: (data) => ({
                path: ApiUrls.ADDITIONAL_EMAILS_CONFIRMED(),
                method: 'POST',
                data,
            }),
        }),
    }),
});
